import React from 'react';
import Box from '@material-ui/core/Box';
import StyledLinearProgress from './StyledLinearProgress.view';
import {IPropsView} from '../Config/ProgressBar.types';
import Typography from '@material-ui/core/Typography';
import '../Style/ProgressBar.css';

const ProgressBarView = (props:IPropsView) => (
    <div className={props.className}>
        <Box className='progress-width-full'>
            <Box className='progress-width-full' mr={1}>
                <StyledLinearProgress variant='determinate' {...props} />
            </Box>
            <Box className='box-loading'>
                <Typography variant='body2' color='textSecondary'>{props.title}</Typography>
            </Box>
        </Box>
    </div>
);

export default ProgressBarView;
